import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M11.59 7.41L15.17 11H1v2h14.17l-3.59 3.59L13 18l6-6-6-6-1.41 1.41zM20 6v12h2V6h-2z"
}), 'KeyboardTab');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/KeyboardTab.js
// module id = 4354
// module chunks = 2